const eocItems = [
        { courseCode: '430000', courseName: 'Algebra I', subject: 'ALG' },
        { courseCode: '430300', courseName: 'Pre-AP Algebra 1', subject: 'ALG' },
        { courseCode: '530020', courseName: 'Algebra I (requires ADE approval)', subject: 'ALG' },
        { courseCode: '972300', courseName: 'Special Education Mathematics', subject: 'ALG' },
        { courseCode: '431000', courseName: 'Geometry', subject: 'GEO' },
        { courseCode: '431300', courseName: 'Pre-AP Geometry with Statistics', subject: 'GEO' },
        { courseCode: '531020', courseName: 'Geometry (requires ADE approval)', subject: 'GEO' },
        { courseCode: '972350', courseName: 'Math Special Education Self-Contained', subject: 'GEO' },
        { courseCode: '420000', courseName: 'Biology - Integrated', subject: 'BIO' },
        { courseCode: '420100', courseName: 'Pre-AP Biology', subject: 'BIO' },
        { courseCode: '520010', courseName: 'Biology - Integrated (Weighted - requires ADE approval)', subject: 'BIO' },
        { courseCode: '520030', courseName: 'AP Biology', subject: 'BIO' },
        { courseCode: '529030', courseName: 'IB Biology', subject: 'BIO' },
        { courseCode: '529910', courseName: 'Concurrent Credit Biology', subject: 'BIO' },
        { courseCode: '972200', courseName: 'Special Education Science', subject: 'BIO' },
        { courseCode: '973910', courseName: 'Science Special Education Self-Contained', subject: 'BIO' },
  ];

export default eocItems;